import type { MaterialCivilDay } from "../../../../api/SiteDaily";

// Dates of the web Mechanical drawer's rail.
//
// The server sends the task's civil production days and every "no civil
// input" day already pinned to (hours or heads, this log or an earlier one).
// The clerk can open one more such date from the rail's picker: it appears
// as an empty no-output day for every machine, and what is typed there is
// saved pinned to that date — no target, stays on the day (user, 2026-10-24).

/** An empty day with no civil production: nothing required, nothing booked. */
export const noOutputDayOf = (workDate: string): MaterialCivilDay => ({
  workDate,
  producedQty: "0",
  requiredQty: "0",
  bookedQty: "0",
  bookedTodayQty: "0",
  pendingQty: "0",
  bookedAmount: "",
  bookedPricedQty: "",
  earlierHeads: [],
  todayHeads: [],
  noOutput: true,
});

/** The server's days plus a no-output day for each picked date it did not send. */
export const withExtraDays = (days: MaterialCivilDay[], extraDates: string[]): MaterialCivilDay[] => {
  const missing = extraDates.filter((date) => !days.some((day) => day.workDate === date));
  return missing.length ? [...days, ...missing.map(noOutputDayOf)] : days;
};

/**
 * A saved log split back into the drawer's boxes. Each civil date's box holds
 * the date's WHOLE booking, whichever logs entered it (the date owns it —
 * user, 2026-10-26) — except the log date itself, whose box is this log's own
 * part there. The own-day box keeps only what this log has on no date at all:
 * its hours less its allocation on every date, pinned or not.
 */
export const splitSavedHours = (
  line: { hoursWorked: string; civilDays: Array<{ workDate: string; bookedQty: string; bookedTodayQty: string }> },
  logDate: string
): { hoursWorked: string; pendingDays: Record<string, string> } => {
  const pendingDays: Record<string, string> = {};
  let onDays = 0;
  line.civilDays.forEach((day) => {
    const whole = day.workDate === logDate ? day.bookedTodayQty : day.bookedQty;
    if (Number(whole) > 0) pendingDays[day.workDate] = whole;
    const mine = Number(day.bookedTodayQty);
    if (mine > 0) onDays += mine;
  });
  if (line.hoursWorked === "" || onDays <= 0) return { hoursWorked: line.hoursWorked, pendingDays };
  const rest = Math.round((Number(line.hoursWorked) - onDays) * 10000) / 10000;
  return { hoursWorked: rest > 0.00005 ? String(rest) : "", pendingDays };
};
